import { AnswerFeedback } from '../../../../../components/AgentChat/AnswerFeedback'
import { useAnswerFeedback } from '../../../../../hooks/useAgentConversation'
import { ChatItem } from '../../../../../models/agentConversation'

/** The staff feedback buttons under one Insure agent answer, saved through the Insure endpoint. */
export function StaffAnswerFeedback({
  item,
  conversationId,
}: {
  item: ChatItem
  conversationId: string | undefined
}) {
  const { save, clear } = useAnswerFeedback(conversationId, item.id)
  return (
    <AnswerFeedback
      feedback={item.feedback ?? null}
      traceUrl={item.traceUrl}
      onSave={(feedback) => save.mutateAsync(feedback)}
      onClear={() => clear.mutateAsync()}
      className="max-w-[80%]"
    />
  )
}
